import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { SideMenuPopular } from '@/components/modules/Layout/SideMenu/SideMenuPopular/SideMenuPopular';
import { CaseOneContentSkeleton } from '@/components/modules/pages/case/content/CaseOneContent';
import { ContentContainer } from '@/components/ui/Layout/ContentContainer/ContentContainer';
import Breadcrumb from '@/container/Layout/Breadcrumb';
import { columnListPath, myPagePath, caseListPath } from '@/utils/router/links';
/**
 * 事例紹介詳細ページの View 部分のコンポーネント（ローディング表示）
 * @param props
 * @returns
 */
export const CaseOneViewSkeleton = (props) => {
    const { isGuestUser, isProfessionalUser } = props;
    const pans = useMemo(() => {
        const myPage = { link: myPagePath(), text: 'マイページ' };
        const common = [{ link: caseListPath(), text: '選定支援事例' }];
        return !isGuestUser ? [myPage, ...common] : common;
    }, [isGuestUser]);
    return (_jsxs(_Fragment, { children: [_jsx(Breadcrumb, { lists: pans }), _jsxs(ContentContainer, Object.assign({ className: clsx('flex flex-col lg:flex-row', 'gap-80 lg:gap-48', 'mx-auto mb-80'), maxWidthPoint: 'xl' }, { children: [_jsx(CaseOneContentSkeleton, {}), _jsx(SideMenuPopular, { className: clsx('flex-shrink-0', 'w-full lg:w-[270px]'), isGuestUser: isGuestUser, isLoadingPopularCase: true, isLoadingPopularConsultant: true, isLoadingWeeklyRankingList: true, isProfessionalUser: isProfessionalUser, onClickRegistration: () => { }, popularCases: undefined, popularConsultantList: undefined, popularConsultantListHasMoreLink: '', weeklyRankingList: undefined, weeklyRankingListLimit: 7, weeklyRankingMoreLink: columnListPath() })] }))] }));
};
